<script lang="ts">
  import type { TopPriceChangesOutput } from "../../api/spend-report";
  import TextNew from "../TextNew.svelte";
  import AlarmBellSnoozeIcon from "../icons/AlarmBellSnoozeIcon.svelte";
  import PriceChangeItem from "./PriceChangeItem.svelte";
  import PriceChangeSkeletonRow from "./PriceChangeSkeletonRow.svelte";

  export let priceChanges: TopPriceChangesOutput["price_changes"] | undefined;
  export let isLoading: boolean;
  export let xl: boolean;

  const skeletonRows = new Array(3).fill(null);
</script>

<div class="card" class:empty-card={isLoading}>
  {#if priceChanges?.length}
    {#each priceChanges as priceChangeItem (priceChangeItem.id)}
      <PriceChangeItem
        title={priceChangeItem.name}
        totalSpend={priceChangeItem.total_spend}
        prevPrice={priceChangeItem.previous_price_cents}
        currPrice={priceChangeItem.current_price_cents}
      />
    {/each}
  {:else if isLoading}
    {#each skeletonRows as _}
      <PriceChangeSkeletonRow />
    {/each}
  {:else}
    <div class="empty" class:xl-card={xl} class:sm-card={!xl}>
      <AlarmBellSnoozeIcon size={60} />
      <TextNew size="xs" tabular --rk-text-color="var(--rk-text-low)">No price changes</TextNew>
    </div>
  {/if}
</div>

<style>
  .card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 12px;
    width: 100%;
    border: 1px solid var(--rk-divider-0);
    background: var(--rekki-light);
  }

  .sm-card {
    min-height: 152px;
  }

  .xl-card {
    min-height: 405px;
  }

  .empty-card {
    gap: 22px;
    padding: 19px 16px;
  }

  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
</style>
